import type { Form } from '@/components/partials/public-portfolio/PortfolioJobsInquirySection/PortfolioJobsInquirySectionProfile/types';

export interface GetOTEValidationRulePayload {
  form: Form;
  required: boolean;
}

export const userFields = {
  PHONE: 'phone',
  FIRSTNAME: 'firstname',
  LASTNAME: 'lastname',
  WAR_ROOM_YEARS_OF_EXPERIENCE: 'warRoomYearsOfExperience',
  POSITION: 'position',
  DEPARTMENTS: 'departments',
  PRODUCT_TYPES: 'productTypes',
  INDUSTRIES: 'industries',
  WAR_ROOM_SALES_ROLES: 'warRoomSalesRoles',
  COMPANY_SERIES_STAGES: 'companySeriesStages',
  LINKEDIN_URL: 'linkedinUrl',
} as const;

export const jobsInquiryFormFields = Object.freeze({
  ...userFields,

  // JobsInquiry fields
  BASE_SALARY: 'baseSalary',
  CLIENTS: 'clients',
  COMPANY_STAGES: 'desiredCompanySeriesStages',
  DEAL_BREAKER_OTHER: 'dealBreakerOther',
  DEAL_BREAKERS_MAIN: 'dealBreakersMain',
  DEAL_SIZE: 'dealSize',
  EMPLOYMENT_TYPES: 'employmentTypes',
  IDEAL_JOB_DESCRIPTION: 'idealJobDescription',
  CURRENCY: 'currency',
  OTE: 'ote',
  POSITION_MAIN: 'positionMain',
  POSITION_OTHER: 'positionOther',
  QUOTA_ATTAINMENT_BY_TEAM_PER_PERIOD: 'quotaAttainmentByTeamPerPeriod',
  QUOTA_ATTAINMENT_PER_LAST_YEAR: 'quotaAttainmentPerLastYear',
  QUOTA_ATTAINMENT_PER_PERIOD: 'quotaAttainmentPerPeriod',
  RANK_ON_TEAM: 'rankOnTeam',
  REVENUE: 'revenue',
  SALES_CYCLE_LENGTH: 'salesCycleLength',
  SALES_METHODOLOGIES: 'salesMethodologies',
  TEAM_SIZE: 'teamSize',
  WILLING_TO_RELOCATE: 'willingToRelocate',
  DESIRED_COMPANY_SERIES_STAGES: 'desiredCompanySeriesStageIds',

  AE_LEAD_SOURCE_OTHER: 'aeLeadSourceOther',
  AE_LEAD_SOURCE_MAIN: 'aeLeadSourcesMain',
  AE_QUOTA_PER_PERIOD: 'aeQuotaPerPeriod',
  AE_QUOTA_TYPE_MAIN: 'aeQuotaTypeMain',
  AE_QUOTA_TYPE_OTHER: 'aeQuotaTypeOther',

  SDR_QUOTA_PER_PERIOD: 'sdrQuotaPerPeriod',
  SDR_QUOTA_TYPES: 'sdrQuotaTypes',

  CSM_TOTAL_BUSINESS_VALUE: 'csmTotalBusinessValue',
  CSM_ACCOUNTS_NUMBER: 'csmAccountsNumber',
  CSM_QUOTA_TYPE_MAIN: 'csmQuotaTypeMain',
  CSM_QUOTA_TYPE_OTHER: 'csmQuotaTypeOther',
  CSM_QUOTA_METRIC_MAIN: 'csmQuotaMetricMain',
  CSM_QUOTA_METRIC_OTHER: 'csmQuotaMetricOther',
  CSM_QUOTA_PERIOD_MAIN: 'csmQuotaPeriodMain',
  CSM_QUOTA_PERIOD_OTHER: 'csmQuotaPeriodOther',
  CSM_RENEWAL_VALUE: 'csmRenewalValue',
  CSM_UPSELL_VALUE: 'csmUpsellValue',

  VP_DEPARTMENT_SIZE: 'vpDepartmentSize',
  VP_MANAGED_ROLES: 'vpManagedRoles',
  VP_QUOTA_TYPE: 'vpQuotaType',
});

export const getOteIsLowerThanBaseSalaryValidation =
  ({ form, required }: GetOTEValidationRulePayload) =>
  (value: number) => {
    if (!required) return true;
    if (isNaN(value)) return true;
    if (!form.baseSalary) return true;

    return Boolean(value > form.baseSalary);
  };
